/** Amount with its currency code; a plain number when the currency is unknown. */
export const formatMoney = (
  value: number,
  currency: string | null | undefined,
  language: string
) => {
  try {
    return value.toLocaleString(language, {
      style: 'currency',
      currency: currency || undefined,
      currencyDisplay: 'code',
    });
  } catch (error) {
    return value.toLocaleString(language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
};
